import { useSyncExternalStore } from "react";

/* ══════════════════════════════════════════════════════════════════
   Ob das Fenster „Ortsaufnahme anlegen" offen ist — und womit (08.10.2026).

   Luca: *„Wenn ich über ‚Neu' und ‚Aufmaß' gehe, muss direkt das Pop-up
   aufgehen. Dann brauche ich nicht extra dieses Ortsaufnahmen-Modul."*

   **Ein Fenster für die ganze Anwendung**, gezeichnet in der Schale
   (`schale/Schale.tsx`), geöffnet von „Neu" im Kopf, aus Angebot und
   Auftrag („Aufmaß bestellen", „Ortsaufnahme anlegen") und aus der Liste.
   Die Stellen liegen in verschiedenen Zweigen des Baums; dieselbe Bauform
   wie das Nachschlagen (`schale/nachschlagen.ts`).

   **Wer öffnet, gibt mit, was er weiß** (Regel 11): Kunde, Ort, Leistung
   oder die Position, die auf die Zahl wartet. Das Fenster liest es beim
   Aufgehen; jedes Öffnen zählt hoch (`nr`), damit ein zweites Öffnen mit
   anderer Vorbelegung nicht den Entwurf des ersten zeigt.
   ══════════════════════════════════════════════════════════════════ */

/** Was das Fenster vorbelegt bekommt. Alles freiwillig. */
export type Ortsaufnahmevorgabe = {
  /** Kundennummer — das Fenster holt die Akte (Orte) dazu. */
  kundeNr?: string;
  /** Bezeichnung des Einsatzorts, wie in der Kundenakte. */
  ort?: string;
  leistungsartId?: string;
  /** Die Position, die auf die Zahl wartet — dann ist es eine Bestellung (Kunde, Ort, Leistung stehen fest). */
  positionId?: string;
  /** Für den Satz unter dem Titel: „aus V-2026-1090". */
  vorgang?: string;
  /**
   * Aus einem Angebot ohne wartende Zeile: Die neue Aufnahme wird ihm danach
   * zugeordnet (Paket aufnahmen2) — nur, solange der Kunde der des Angebots bleibt.
   */
  zuordnenAn?: string;
  /** Was die Position sagt — Kennung der Leistung als Wort, zur Anzeige. */
  leistung?: string;
  kunde?: string;
};

type Stand = { offen: boolean; nr: number; vorgabe: Ortsaufnahmevorgabe };

let stand: Stand = { offen: false, nr: 0, vorgabe: {} };
const hoerer = new Set<() => void>();

function melden(): void {
  hoerer.forEach((ruf) => ruf());
}

/** Das Fenster öffnen — mit dem, was die Stelle schon weiß. */
export function ortsaufnahmeOeffnen(vorgabe: Ortsaufnahmevorgabe = {}): void {
  stand = { offen: true, nr: stand.nr + 1, vorgabe };
  melden();
}

export function ortsaufnahmeSchliessen(): void {
  if (!stand.offen) return;
  stand = { ...stand, offen: false };
  melden();
}

function anmelden(ruf: () => void): () => void {
  hoerer.add(ruf);
  return () => { hoerer.delete(ruf); };
}

const jetzt = () => stand;
const zu: Stand = { offen: false, nr: 0, vorgabe: {} };
const nie = () => zu;

export function useOrtsaufnahmeStand(): Stand {
  return useSyncExternalStore(anmelden, jetzt, nie);
}
